<template>
  <div class="customers pb-9">
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">گزارش عملکرد مرسولات پستی</h4>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading">
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else>
        <v-container class="pt-1">
          <v-row>
            <v-col class="date_picker pb-0" md="4" cols="12">
              <label class="title-form-panel">از تاریخ:</label>
              <span id="fromDate"
                ><v-text-field
                  dense
                  outlined
                  v-model="startDate"
                  append-icon="mdi-calendar"
                  class="date-input"
                  placeholder="از تاریخ"
                ></v-text-field
              ></span>
              <date-picker
                element="fromDate"
                v-model="startDate"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="date_picker pb-0" md="4" cols="12">
              <label class="title-form-panel">تا تاریخ:</label>
              <span id="toDate"
                ><v-text-field
                  dense
                  outlined
                  v-model="endDate"
                  append-icon="mdi-calendar"
                  class="date-input"
                  placeholder="تا تاریخ"
                ></v-text-field
              ></span>
              <date-picker
                element="toDate"
                v-model="endDate"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="date_picker pb-0 mt-7" md="4" cols="12">
              <v-btn
                @click="shippingReport"
                class="primary-mainBtn"
                block
                height="40"
                :disabled="!startDate || !endDate"
                >اعمال</v-btn
              >
            </v-col>
          </v-row>
          <hr />
          <v-row class="header">
            <v-col class="col" lg="6" md="6" cols="12">
              <v-card class="common-card">
                <div>
                  <div class="purple-iconBox">
                    <v-icon>mdi-email-plus</v-icon>
                  </div>
                  <span class="box-header">تعداد مرسولات</span>
                </div>
                <h5>{{ Number(total).toLocaleString() }}</h5>
              </v-card>
            </v-col>
            <v-col class="col" lg="6" md="6" cols="12">
              <v-card class="common-card">
                <div>
                  <div class="blue-iconBox">
                    <v-icon>mdi-cash-multiple</v-icon>
                  </div>
                  <span class="box-header">هزینه پست دریافتی</span>
                </div>
                <h5>{{ Number(totalAmount).toLocaleString() }} تومان</h5>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import Axios from "axios";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    AtomSpinner,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      loading: false,
      currentDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      startDate: "",
      endDate: "",
      total: 0,
      totalAmount: 0,
    };
  },
  methods: {
    shippingReport() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/reports/shippingReport",
        {
          startDate: this.startDate,
          endDate: this.endDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.total = res.data.total;
            this.totalAmount = res.data.totalAmount;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
  },
  computed: {},
  mounted() {
    this.startDate = moment(this.currentDate, "jYYYY/jMM/jDD").format("X");
    this.startDate = this.startDate - 1 * 86400;
    this.startDate = moment(this.startDate, "X").format("jYYYY/jMM/jDD");
    this.endDate = this.currentDate;
    this.shippingReport();
  },
};
</script>
<style lang="scss">
.customers {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
  .header {
    .v-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 140px;

      .box-header {
        color: hsl(229, 49%, 25%);
        padding-top: 7px;
        padding-right: 14px;
      }
      h5 {
        color: #4e536a;
        font-size: 20px;
        margin: 0;
      }
    }
  }
}
</style>
